/* 🤖 this file was generated by svg-to-ts */
export const prizmIconsSeparator: {
  name: 'separator';
  data: string;
} = {
  name: 'separator',
  data: `<svg fill="none" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24"><path fill-rule="evenodd" clip-rule="evenodd" d="M6 4a2 2 0 0 1 2-2h8a2 2 0 0 1 2 2v2h2a1 1 0 1 1 2 0v6a1 1 0 1 1-2 0h-2v8a2 2 0 0 1-2 2H8a2 2 0 0 1-2-2v-8H4a1 1 0 1 1-2 0V6a1 1 0 0 1 2 0h2V4ZM4 8v2h2V8H4Zm14 0h2v2h-2V8Zm-2 3V8H8v8h8v-5Zm-8 7v2h8v-2H8ZM8 4h8v2H8V4Z" fill="currentColor"/></svg>`,
};
